/**
 * Normalise admin detail payloads so the email thread UI always reads `emailMessages`.
 * Backend may return `emailMessages` or legacy `emailThread`.
 *
 * @param {Record<string, unknown> | null | undefined} detail
 * @returns {Record<string, unknown> | null | undefined}
 */
export function mergeEmailMessagesIntoDetail(detail) {
  if (!detail || typeof detail !== "object") return detail;
  const emailMessages = Array.isArray(detail.emailMessages)
    ? detail.emailMessages
    : Array.isArray(detail.emailThread)
      ? detail.emailThread
      : [];
  return { ...detail, emailMessages };
}

function sortEmailMessagesByCreatedAt(arr) {
  return [...arr].sort(
    (a, b) =>
      new Date(a?.createdAt || 0).getTime() - new Date(b?.createdAt || 0).getTime()
  );
}

/**
 * Insert or replace by `message.id` (Socket.io / optimistic merge).
 *
 * @param {unknown[]} list
 * @param {Record<string, unknown>} message
 * @returns {unknown[]}
 */
export function upsertEmailMessageInList(list, message) {
  if (!message || typeof message !== "object") return Array.isArray(list) ? list : [];
  const mid = message.id != null ? String(message.id) : "";
  const arr = Array.isArray(list) ? [...list] : [];
  if (!mid) {
    arr.push(message);
    return sortEmailMessagesByCreatedAt(arr);
  }
  const i = arr.findIndex((m) => m && String(m.id) === mid);
  if (i >= 0) {
    arr[i] = { ...arr[i], ...message };
    return sortEmailMessagesByCreatedAt(arr);
  }
  arr.push(message);
  return sortEmailMessagesByCreatedAt(arr);
}

/**
 * @param {unknown[]} list
 * @param {string} emailMessageId
 * @param {unknown} clientAnalysis
 * @returns {unknown[]}
 */
export function patchEmailMessageClientAnalysis(list, emailMessageId, clientAnalysis) {
  const arr = Array.isArray(list) ? [...list] : [];
  const i = arr.findIndex((m) => m && String(m.id) === String(emailMessageId));
  if (i < 0) return arr;
  arr[i] = { ...arr[i], clientAnalysis };
  return arr;
}
